module.exports = __webpack_public_path__ + "static/assets/507921e4368d569657b415fb186c0822.png";